import { useEffect, useState } from "react";
import { useImmer } from "use-immer";
import { Card } from "@components/Card";
import { Button } from "@components/Button";
import { Btn } from "../../../../../Customer/views/NewOrderPage/Elements/Element/Element";
import { Field } from "../Field";
import { DrillingTable } from "./DrillingTable";
import cs from "./AdditionalProcessing.module.scss";

export const Threading = ({ priceList, onChange, onRemove }) => {
  const [draft, setDraft] = useImmer({});
  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    setDraft(priceList);
  }, [priceList]);

  const pricing = draft.pricings?.[0];

  if (!pricing) return null;

  const { prices = {} } = pricing;

  return (
    <Card className="PriceList">
      <Card.Header className="PriceList_header">
        <div className="h5">{priceList.service.name}</div>

        <Button
          type="secondary"
          size="small"
          onClick={() => onRemove(pricing._id)}
        >
          Usuń usługę
        </Button>
      </Card.Header>

      <Card.Body className={cs.service}>
        <Field
          label="Koszt nastawy maszyny:"
          name="setup"
          value={prices.setup}
          isEdited={isEdited}
          unit="zł"
          onChange={handleChange}
        />

        <DrillingTable
          rows={prices.table}
          label="Średnica zewnętrzna gwintu"
          readOnly={!isEdited}
          onChange={(updatedTable) => handleChange("table", updatedTable)}
        />

        <div>
          {isEdited ? (
            <Btn onClick={handleSave}>Zapisz zmiany</Btn>
          ) : (
            <Btn onClick={() => setIsEdited(true)}>Edytuj</Btn>
          )}
        </div>
      </Card.Body>
    </Card>
  );

  function handleChange(field, value) {
    setDraft((prev) => {
      if (!prev.pricings[0].prices) {
        prev.pricings[0].prices = {};
      }

      prev.pricings[0].prices[field] = value;
    });
  }

  function handleSave() {
    setIsEdited(false);

    onChange(draft);
  }
};
